import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useMediaQuery } from 'react-responsive';

import NavigationBreadcrumbItem from './NavigationBreadcrumbsItem';
import { getTruncatedBreadcrumbTrail } from './helpers';
import { breakpointDown } from '../../../services/responsive/responsive';
import useNavigationBreadcrumbScroll from './useNavigationBreadcrumbScroll';

const propTypes = {
  className: PropTypes.string,
  trail: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.node.isRequired,
      path: PropTypes.string,
      onClick: PropTypes.func,
    }).isRequired,
  ).isRequired,
  activeIndex: PropTypes.number,
  maxCrumbs: PropTypes.number,
  mobileMaxCrumbs: PropTypes.number,
  separator: PropTypes.oneOf(['arrows', 'bullets']),
  renderEllipsis: PropTypes.func,
  breakpoint: PropTypes.oneOf(['sm', 'md', 'lg', 'xl']),
};

const NavigationBreadcrumbs = ({
  className,
  trail,
  maxCrumbs = 4,
  mobileMaxCrumbs = maxCrumbs,
  activeIndex,
  separator = 'arrows',
  renderEllipsis,
  breakpoint = 'sm',
}) => {
  const ref = useRef();
  const activeRef = useRef();
  const mobile = useMediaQuery(breakpointDown(breakpoint));
  const classes = classNames({
    'navigation-breadcrumbs': true,
    [`navigation-breadcrumbs-separator-${separator}`]: true,
    [className]: !!className,
  });

  const max = mobile ? mobileMaxCrumbs : maxCrumbs;
  const { trail: finalTrail, skipped } = getTruncatedBreadcrumbTrail(
    trail,
    max,
    activeIndex,
  );

  useNavigationBreadcrumbScroll(ref, activeRef, activeIndex);

  return (
    <div className={classes} ref={ref}>
      {finalTrail.map((crumb, index) => (
        <NavigationBreadcrumbItem
          key={index}
          crumb={crumb}
          ref={index === activeIndex ? activeRef : undefined}
          separator={separator}
          renderEllipsis={
            renderEllipsis
              ? opts => renderEllipsis({ skipped, ...opts })
              : undefined
          }
        />
      ))}
    </div>
  );
};

NavigationBreadcrumbs.propTypes = propTypes;

export default NavigationBreadcrumbs;
